module.exports = __webpack_public_path__ + "media/images/top-content-img-10-44442537fc9b3d2714f0b2b267284840.jpg";